import Facebook from './Facebook'
import store from '../vuex/store'

export default class Campaigns extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  fetchCampaigns () {
    const account = this.connection().account
    const fields = [
      'id', 'name', 'status', 'effective_status', 'objective', 'lifetime_budget', 'daily_budget',
      'start_time', 'stop_time', 'recommendations', 'adlabels'
    ]
    return account.getCampaigns(fields, [])
      .then(res => {
        const campaigns = []
        for (let i = 0; i < res.length; i++) {
          const campaign = res[i]._data
          if (campaign.lifetime_budget) campaign.lifetime_budget /= 100
          if (campaign.daily_budget) campaign.daily_budget /= 100
          campaigns.push(campaign)
        }
        return campaigns
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  fetchCampaignAdsets () {
    const Campaign = this.SdkClass().Campaign
    let campaign = new Campaign(this.parameters.campaign.id)
    const fields = [
      'name', 'start_time', 'end_time',
      'daily_budget', 'lifetime_budget', 'targeting'
    ]
    return new Promise(resolve => {
      resolve(campaign.getAdSets(fields, []))
        .then(res => {
          const issues = []
          for (let i = 0; i < res.length; i++) {
            issues.push(res[i]._data)
          }
          return issues
        })
        .catch(err => {
          throw new Error(JSON.stringify(err))
        })
    })
  }
  fetchCampaignAds () {
    const Campaign = this.SdkClass().Campaign
    let campaign = new Campaign(this.parameters.campaign.id)
    const fields = [
      'id', 'name', 'adset_id', 'creative'
    ]
    return new Promise(resolve => {
      resolve(campaign.getAds(fields, []))
        .then(res => {
          const messages = []
          for (let i = 0; i < res.length; i++) {
            messages.push(res[i]._data)
          }
          return messages
        })
        .catch(err => {
          throw new Error(JSON.stringify(err))
        })
    })
  }
  fetchCampaignInsights () {
    // const Campaign = this.SdkClass().Campaign
    // let campaign = new Campaign(this.parameters.campaign.id)
    // const fields = [
    //   'impressions', 'spend', 'adset_id', 'campaign_id', 'campaign_name', 'reach', 'cpm', 'cpc',
    //   'clicks', 'ctr', 'cost_per_action_type'
    // ]
    // const params = {
    //   time_range: {
    //     since: this.parameters.startDate,
    //     until: this.parameters.endDate
    //   }
    // }
    // return new Promise(resolve => {
    //   resolve(campaign.getInsights(fields, params))
    // })
    //   .then(res => {
    //     if (res[0]) {
    //       return res[0]._data
    //     } return {}
    //   })
    //   .catch(err => {
    //     throw new Error(JSON.stringify(err))
    //   })
    return new Promise(resolve => {
      resolve(true)
    })
  }
  createCampaign () {
    const account = this.connection().account
    const fields = [
      'id', 'name', 'adlabels', 'status', 'objective',
      'lifetime_budget', 'daily_budget', 'start_time',
      'recommendations'
    ]
    const params = {
      name: this.parameters.campaign.name,
      adlabels: [{name: this.parameters.campaign.type}],
      status: this.parameters.campaign.status,
      objective: this.parameters.campaign.objective,
      bid_strategy: 'LOWEST_COST_WITHOUT_CAP'
    }
    params[this.parameters.campaign.selectedBudget] = this.parameters.campaign[this.parameters.campaign.selectedBudget] * 100
    return account.createCampaign(fields, params)
      .then(res => {
        return res._data
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  editCampaign () {
    const Campaign = this.SdkClass().Campaign
    const campaign = new Campaign(this.parameters.campaign.id)
    const fields = [
      'id', 'name', 'adlabels', 'status', 'objective',
      'lifetime_budget', 'daily_budget', 'start_time',
      'recommendations'
    ]
    const adlabelName = this.parameters.campaign.type || this.parameters.campaign.adlabels[0].name
    const params = {
      name: this.parameters.campaign.name,
      adlabels: [{name: adlabelName}],
      status: this.parameters.campaign.status,
      objective: this.parameters.campaign.objective,
      lifetime_budget: this.parameters.campaign.budget * 100
    }
    return new Promise(resolve => {
      resolve(campaign.update(fields, params))
    })
      .then(res => {
        store.commit('campaigns/EDIT_CAMPAIGN', this.parameters.campaign)
        return res
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
}
